import React, { Component } from "react";
import { defineMessages } from "react-intl";
import mapBackendErrors from "assets/scripts/utils/mapBackendErrors";
import Form from "assets/scripts/components/common/form/Form/Form";
import AuthorizedPersonInput from "./AuthorizedPersonInput/AuthorizedPersonInput";
const messages = defineMessages({
    submit: {
        id: "forms.authIndividual.submit",
        defaultMessage: "OK"
    }
});
export default class AuthIndividualForm extends Component {
    constructor(props, context) {
        super(props, context);
        this._handleAuthIdChange = (authId) => this.setState({ authId });
        this.state = {
            authId: null
        };
        this._handleSubmit = this._handleSubmit.bind(this);
    }
    render() {
        const { props, state } = this;
        const isValid = state.authId != null;
        const { globalError } = mapBackendErrors(props.fieldErrors);
        return (<Form isBusy={props.isLoading} isValid={isValid} onSubmit={this._handleSubmit} submitLabel={messages.submit} error={globalError}>
				<AuthorizedPersonInput authId={state.authId} authIndividuals={props.authIndividuals} onChange={this._handleAuthIdChange}/>
			</Form>);
    }
    _handleSubmit() {
        const { authId } = this.state;
        this.props.setAuthId(authId);
        const validationInfo = this.props.requestData;
        const validationInfoWithAuthId = {
            ...validationInfo,
            authorizedId: authId
        };
        this.props.sendValidation(validationInfoWithAuthId);
        this.props.closeModal({
            modalId: this.props.modalTrigger,
            triggerId: ""
        });
    }
}



// WEBPACK FOOTER //
// ./src/assets/scripts/components/forms/public/AuthIndividualForm.tsx